import {
  NARRATIVE_HISTORY_FETCH_FAILED,
  NARRATIVE_HISTORY_FETCH_REQUESTED,
  NARRATIVE_HISTORY_FETCH_SUCCEEDED,
  NARRATIVE_FETCH_FAILED,
  NARRATIVE_FETCH_REQUESTED,
  NARRATIVE_FETCH_SUCCEEDED,
  SET_NARRATIVE,
  TRANSITION_COMPLETED,
  TRANSITION_FAILED,
  TRANSITION_PROPOSED,
  TRANSITION_REQUESTED,
  TRANSITION_SUCCEEDED,
  DASHBOARD_FETCH_REQUESTED,
  DASHBOARD_FETCH_SUCCEEDED,
  DASHBOARD_FETCH_FAILED,
  NARRATIVE_HISTORY_RESET,
} from '../constants'

export const transitionProposed = (narrative, transition) => {
  // ButtonPanel proposes a transition, then ConfirmationPopups confirms it with the user then requests it of the API
  return {
    type: TRANSITION_PROPOSED,
    narrative,
    transition,
  }
}
export const transitionRequested = (narrative, transition) => ({
  type: TRANSITION_REQUESTED,
  narrative,
  transition,
})
export const transitionSucceeded = (narrative, transition) => ({
  type: TRANSITION_SUCCEEDED,
  narrative,
  transition,
})
export const transitionFailed = error => ({
  type: TRANSITION_FAILED,
  error,
})
export const transitionCompleted = () => {
  return {
    type: TRANSITION_COMPLETED,
  }
}

export const setNarrative = narrative => {
  return {
    type: SET_NARRATIVE,
    narrative,
  }
}

export const narrativeHistoryReset = () => {
  return {
    type: NARRATIVE_HISTORY_RESET,
  }
}
export const narrativeHistoryFetchRequested = (cspCountryKey, year) => {
  return {
    type: NARRATIVE_HISTORY_FETCH_REQUESTED,
    cspCountryKey,
    year,
  }
}
export const narrativeHistoryFetchSucceeded = narrativeHistory => {
  return {
    type: NARRATIVE_HISTORY_FETCH_SUCCEEDED,
    narrativeHistory,
  }
}
export const narrativeHistoryFetchFailed = error => {
  return {
    type: NARRATIVE_HISTORY_FETCH_FAILED,
    error,
  }
}

export const narrativeFetchRequested = id => {
  return {
    type: NARRATIVE_FETCH_REQUESTED,
    id,
  }
}
export const narrativeFetchSucceeded = narrative => {
  return {
    type: NARRATIVE_FETCH_SUCCEEDED,
    narrative,
  }
}
export const narrativeFetchFailed = error => {
  return {
    type: NARRATIVE_FETCH_FAILED,
    error,
  }
}

export const dashboardFetchRequested = id => {
  return {
    type: DASHBOARD_FETCH_REQUESTED,
  }
}
export const dashboardFetchSucceeded = dashboard => {
  return {
    type: DASHBOARD_FETCH_SUCCEEDED,
    dashboard,
  }
}
export const dashboardFetchFailed = error => {
  return {
    type: DASHBOARD_FETCH_FAILED,
    error,
  }
}
